
import React ,{useEffect}from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./pagestyles/OpinionDetail.css";


// Example articles data — replace with API if needed
const featuredArticle = {
  slug: "china-world-split",
  title: "A World Split in Two Is Just What China Wants",
  image: "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=800&h=400&fit=crop",
  author: "Karishma Vaswani",
  content: `
    <p>China’s geopolitical ambitions are reshaping the modern world...</p>
    <p>From economic strategies to diplomatic alliances...</p>
    <p>This divide will define the next decade of global politics...</p>
  `,
};

const secondaryArticles = [
  {
    slug: "/article/new-trade-policies-announced",
    title: "US-China Tensions Escalate in Trade Talks",
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=1200&h=600&fit=crop",
    author: "John Smith",
  },
  {
    slug: "/article/global-economic-outlook-resilience",
    title: "Global Economy Shifts Amid Political Uncertainty",
    image: "https://images.unsplash.com/photo-1554224154-22dec7ec8818?w=600&h=400&fit=crop",
    author: "Emily Clark",
  },
  {
    slug: "/article/ecommerce-growth-continues",
    title: "Tech Giants Caught in Geopolitical Crossfire",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600&h=400&fit=crop",
    author: "Rajesh Kumar",
  },
];

      const OpinionDetail = () =>{
      useEffect(() => {
      window.scrollTo(0, 0);
         }, []);
            return (
    <>

      <Helmet>
        <title>{featuredArticle.title} | Redbox Global Opinion</title>
        <meta name="description" content={featuredArticle.content.replace(/<[^>]+>/g, "").slice(0, 150)} />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="page-container">
        {/* Featured Article */}
        <div className="featured-article">
          <div className="featured-image">
            <img src={featuredArticle.image} alt={featuredArticle.title} />
          </div>
          <div className="featured-content">
            
            <h2>{featuredArticle.title}</h2>
            <p className="author-byline">By {featuredArticle.author}</p>
            <div
              className="article-text"
              dangerouslySetInnerHTML={{ __html: featuredArticle.content }}
            ></div>
          </div>
        </div>

        {/* Secondary Articles */}
        <div className="content-grid">
          {secondaryArticles.map((article, index) => (
            <Link key={index} to={article.slug} style={{ textDecoration: "none", color: "inherit" }}>
              <article className="article-card">
                <div className="article-image">
                  <img src={article.image} alt={article.title} />
                </div>
                <div className="article-content">
                  
                  <h2>{article.title}</h2>
                  <p className="author-byline">By {article.author}</p>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default OpinionDetail;





